import CityPage from '../../components/CityPage';

const cityData = {
    name: "Trouville-sur-Mer",
    slug: "trouville-sur-mer",
    postalCode: "14360",
    intro: "CC Débarras 14 intervient à Trouville-sur-Mer pour tous vos débarras, qu'il s'agisse d'une succession, d'un départ en maison de retraite ou d'un simple vide-maison. Résidences principales ou secondaires, appartements en bord de mer, maisons de famille : nous nous occupons du tri, du chargement et de l'évacuation de l'ensemble de vos affaires. Notre équipe intervient rapidement et dans le plus grand respect de votre bien.",
    nearby: ["Deauville", "Touques", "Villerville", "Honfleur", "Bénerville-sur-Mer"],
};

const TrouvilleSurMer = () => <CityPage city={cityData} />;

export default TrouvilleSurMer;
